// Single source of truth for the sport navigator order + labels.
// Both the desktop radio toggle and the mobile menu map over this array,
// so reordering is a one-line change here and stays in sync automatically.
//
// clearAnalyticsOnSelect: when true, switching to this sport exits the
// analytics overlay if it's open. MLB is the only sport that keeps analytics
// mode active on selection (analytics is an MLB-native feature).
export const SPORTS_NAV = [
  { key: 'nba',    label: 'NBA',    clearAnalyticsOnSelect: true  },
  { key: 'nfl',    label: 'NFL',    clearAnalyticsOnSelect: true  },
  { key: 'nhl',    label: 'NHL',    clearAnalyticsOnSelect: true  },
  { key: 'ncaaf',  label: 'NCAAF',  clearAnalyticsOnSelect: true  },
  { key: 'soccer', label: 'Soccer', clearAnalyticsOnSelect: true  },
  { key: 'ncaab',  label: 'NCAAB',  clearAnalyticsOnSelect: true  },
  { key: 'mlb',    label: 'MLB',    clearAnalyticsOnSelect: false },
  { key: 'wnba',   label: 'WNBA',   clearAnalyticsOnSelect: true  },
];
